export const educationData = [
    {
        id: 1,
        institution: 'Technical University of Ilmenau, Germany',
        course: 'B.Sc. in Mechatronics',
        startYear: '2019',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Mansoura University, Egypt',
        course: 'B.Sc. in Mechanical Engineering',
        startYear: '2015',
        endYear: '2018 (Not Completed)'
    },
    {
        id: 3,
        institution: 'Biqas Secondary School',
        course: 'Higher Secondary Education',
        startYear: '2012',
        endYear: '2015'
    },
];
